import { API_BASE } from "../config";

// 🔍 Get restaurant + table from token
export const fetchTableByToken = async (token) => {
  const res = await fetch(`${API_BASE}/api/restaurantTable/table`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-QR-Token": token // ✅ IMPORTANT: add this
    }
  });

  if (!res.ok) {
    if (res.status === 400) throw new Error("Missing token");
    if (res.status === 401) throw new Error("Invalid QR");
    if (res.status === 429) throw new Error("Too many requests");
    throw new Error("Server error");
  }

  return res.json();
};

// ⭐ Send feedback
export const sendFeedbackApi = async (payload, token) => {
  const res = await fetch(`${API_BASE}/api/feedback`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-QR-Token": token   // ✅ ADD THIS
    },
    body: JSON.stringify(payload)
  });
  return res.json();
};

// 📊 Track events
export const trackEvent = async (payload, token) => {
  return fetch(`${API_BASE}/api/events`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-QR-Token": token // ✅ KEY CHANGE
    },
    body: JSON.stringify(payload)
  });
};